import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const link = this.element.querySelector('a[data-active="true"]')
    if (!link || this.#isVisible(link)) return

    this.element.scrollTop += this.#centeringOffset(link)
  }

  #isVisible(link) {
    const container = this.element.getBoundingClientRect()
    const { top, bottom } = link.getBoundingClientRect()

    return top >= container.top && bottom <= container.bottom
  }

  #centeringOffset(link) {
    const container = this.element.getBoundingClientRect()
    const { top, height } = link.getBoundingClientRect()

    return top - container.top - (container.height - height) / 2
  }
}
